// @ts-nocheck
import { useState } from "react";
import { Accordion } from "react-bootstrap";

import { useGetNotesByTypeAndTypeIdQuery } from "api/memberPortal/notes/notes.api";

import Note from "./Note";
import AMNoteForm from "./NoteForms/AMNoteForm.modal";
import PPNoteForm from "./NoteForms/PPNoteForm.modal";
import ProductNoteForm from "./NoteForms/ProductNoteForm.modal";
import TQNoteForm from "./NoteForms/TqNoteForm.modal";
import NistNoteForm from "./NoteForms/NistNoteForm";
import EarNoteForm from "./NoteForms/EarNoteForm";

const NOTES = [];

export default function Notes({ item, note_type, id, allowReplies = true }) {
  const [showProductNoteModal, setShowProductNoteModal] = useState(false);
  const [showTechnicalQueryModal, setShowTechnicalQueryModal] = useState(false);
  const [showAMNoteModal, setShowAMNoteModal] = useState(false);
  const [showPPNoteModal, setShowPPNoteModal] = useState(false);
  const [showNistNoteModal, setShowNistNoteModal] = useState(false);
  const [showEarNoteModal, setShowEarNoteModal] = useState(false);
  const [currentNote, setCurrentNote] = useState({});
  const [inResponseTo, setInResponseTo] = useState();
  const [expandAll, setExpandAll] = useState(false);
  const [selectedNotes, setSelectedNotes] = useState([]);

  const { data: notes = NOTES } = useGetNotesByTypeAndTypeIdQuery({
    noteType: note_type,
    noteTypeId: id,
    allowReplies: allowReplies,
  }, {
    refetchOnMountOrArgChange: true,
  });

  let accordionClasses = "my-4"

  if (note_type === "nist") {
    accordionClasses = "border-top-0"
  }

  const openNoteModal = (replyTo = null, note = null) => {
    if (note?.in_response_to) {
      setInResponseTo(note?.in_response_to.note_id);
    } else {
      setInResponseTo(replyTo);
    }
    setCurrentNote(note);

    const modalMap = {
      technical_query: () => setShowTechnicalQueryModal(true),
      product: () => setShowProductNoteModal(true),
      assurance_maintenance: () => setShowAMNoteModal(true),
      protection_profile: () => setShowPPNoteModal(true),
      nist: () => setShowNistNoteModal(true),
      "ear-review": () => setShowEarNoteModal(true),
    };

    const openModal = modalMap[note_type];
    openModal();
  };

  const accordionTitle = () => {
    if (note_type === "product") {
      return <h6>Project Notes</h6>;
    } else if (note_type === "nist") {
      return <h4>Certificate Review Notes</h4>;
    } else if (note_type === "ear-review") {
      return <h6 className="fw-bold text-dark">NOTES</h6>;
    } else {
      return <h6 className="fw-bold text-dark">INTERNAL NOTES</h6>;
    }
  };

  const modals = {
    technicalQuery: {
      open: () => setShowTechnicalQueryModal(true),
      close: () => setShowTechnicalQueryModal(false),
    },
    product: {
      open: () => setShowProductNoteModal(true),
      close: () => setShowProductNoteModal(false),
    },
    assuranceMaintenance: {
      open: () => setShowAMNoteModal(true),
      close: () => setShowAMNoteModal(false),
    },
    protectionProfile: {
      open: () => setShowPPNoteModal(true),
      close: () => setShowPPNoteModal(false),
    },
    nist: {
      open: () => setShowNistNoteModal(true),
      close: () => setShowNistNoteModal(false),
    },
    ear: {
      open: () => setShowEarNoteModal(true),
      close: () => setShowEarNoteModal(false),
    }
  };

  return (
    <Accordion className={accordionClasses} flush defaultActiveKey="0">
      <Accordion.Item eventKey="0" data-cy="notes-accordion">
        <Accordion.Header>
          {accordionTitle()}
        </Accordion.Header>
        <Accordion.Body>
          {notes.length > 0 &&
            (!expandAll ? (
              <div>
                <button
                  className="btn btn-primary d-inline-block"
                  style={{ minWidth: 10 }}
                  onClick={() => {
                    setExpandAll(true);
                    setSelectedNotes(notes.map((note) => note.note_id)); // TODO: make sure all nested notes are expanded
                  }}
                >
                  Expand All
                </button>
              </div>
            ) : (
              <div>
                <button
                  className="btn btn-primary d-inline-block"
                  style={{ minWidth: 10 }}
                  onClick={() => {
                    setExpandAll(false);
                    setSelectedNotes([]);
                  }}
                >
                  Collapse All
                </button>
              </div>
            ))}
          <div className="text-end">
            <button
              data-cy="add-note-button"
              className="btn btn-link d-inline-block"
              style={{ minWidth: 10 }}
              onClick={() => openNoteModal()}
            >
              Add
            </button>
          </div>
          {notes.map((note) => (
            <div key={note.note_id}>
              <Note
                note={note}
                note_type={note_type}
                openNoteModal={openNoteModal}
                selectedNotes={selectedNotes}
                setSelectedNotes={setSelectedNotes}
                allowReplies={allowReplies}
              />
            </div>
          ))}
          {/* modals */}
          {showTechnicalQueryModal && (
            <TQNoteForm
              show={showTechnicalQueryModal}
              handleClose={modals.technicalQuery.close}
              note={currentNote}
              tq={item}
            />
          )}
          {showProductNoteModal && (
            <ProductNoteForm
              show={showProductNoteModal}
              handleClose={modals.product.close}
              note={currentNote}
              product={item}
              replyTo={inResponseTo}
            />
          )}
          {showAMNoteModal && (
            <AMNoteForm
              show={showAMNoteModal}
              handleClose={modals.assuranceMaintenance.close}
              note={currentNote}
              maintenance={item}
              replyTo={inResponseTo}
            />
          )}
          {showPPNoteModal && (
            <PPNoteForm
              show={showPPNoteModal}
              handleClose={modals.protectionProfile.close}
              note={currentNote}
              protectionProfile={item}
              replyTo={inResponseTo}
            />
          )}
          {showNistNoteModal && (
            <NistNoteForm
              show={showNistNoteModal}
              handleClose={modals.nist.close}
              note={currentNote}
              nist={item}
              replyTo={inResponseTo}
            />
          )}
          {showEarNoteModal && (
            <EarNoteForm
              show={showEarNoteModal}
              handleClose={modals.ear.close}
              note={currentNote}
              earReview={item}
              replyTo={inResponseTo}
            />
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}
